import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { getGravatarUrl } from "@/lib/gravatar";
import { User } from "lucide-react";

type SupplierAvatarProps = {
  fotoUrl?: string | null;
  chatwootAvatarUrl?: string | null;
  email?: string | null;
  nome?: string;
  size?: number;
  className?: string;
};

export function SupplierAvatar({
  fotoUrl,
  chatwootAvatarUrl,
  email,
  nome,
  size = 40,
  className,
}: SupplierAvatarProps) {
  // Priority: foto_url > chatwoot_avatar_url > gravatar
  const imageUrl = fotoUrl || chatwootAvatarUrl || getGravatarUrl(email, size);
  const initials = nome
    ? nome
        .split(" ")
        .map((n) => n[0])
        .slice(0, 2)
        .join("")
        .toUpperCase()
    : "?";

  return (
    <Avatar className={className} style={{ width: size, height: size }}>
      {imageUrl && <AvatarImage src={imageUrl} alt={nome || "Fornecedor"} />}
      <AvatarFallback>
        {nome ? (
          <span className="text-xs font-medium">{initials}</span>
        ) : (
          <User className="h-4 w-4" />
        )}
      </AvatarFallback>
    </Avatar>
  );
}

